import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId/users')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('users:list')) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() =>
    import('&/features/settings/users/pages/users-page').then((m) => ({ default: m.default })),
  ),
  staticData: { titleKey: 'users' },
});
